import { render, staticRenderFns } from "./SendComment.vue?vue&type=template&id=4d8d4d56&scoped=true"
import script from "./SendComment.vue?vue&type=script&lang=js"
export * from "./SendComment.vue?vue&type=script&lang=js"
import style0 from "./SendComment.vue?vue&type=style&index=0&id=4d8d4d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d4d56",
  null
  
)

export default component.exports